import type { Signer } from "@ethersproject/abstract-signer";
import { Provider, StaticJsonRpcProvider } from "@ethersproject/providers";
import { Contract } from "@ethersproject/contracts";
import { activeNetwork, networks } from "config/networkConfig";
import { getMulticallAddress, getTokenAddress } from "./addressHelpers";
import MulticallABI from "ABI/MulticallABI.json";
import TokenABI from "ABI/TokenABI.json";

const chainId = networks[activeNetwork]["chainId"];
const simpleRpcProvider = new StaticJsonRpcProvider(
  networks[activeNetwork]["rpc"][chainId]
);
export const getContract = (abi: any, address: string, signer?: Signer | Provider) => {
  const signerOrProvider = signer ?? simpleRpcProvider;
  return new Contract(address, abi, signerOrProvider);
};

export const getMulticallContract = () => {
  return getContract(MulticallABI, getMulticallAddress(), simpleRpcProvider);
};

export const getDrivenContract = (signer?: Signer | Provider) => {
  return getContract(TokenABI, getTokenAddress(), signer);
};
